"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerWrapper = exports.AddExpressionButton = exports.CustomSkillTagSelect = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
exports.CustomSkillTagSelect = (0, styled_components_1.default)(elements_1.Select) `
	width: 100%;
	.ant-select-selector {
		padding: 0.25rem;
	}
`;
exports.AddExpressionButton = (0, styled_components_1.default)(elements_1.Button) `
	width: 100%;
	display: flex;
	align-items: center;
	padding: 0.25rem 0.75rem;
`;
exports.SpinnerWrapper = (0, styled_components_1.default)(elements_1.Spinner) `
	width: 100%;
`;
